import Vue from 'vue';
import firebase from "@/plugins/firebase";
import { database } from "@/plugins/firebase";
import moment from "moment";
import store from "@/store/index";
import { BALANCES } from "@/constants/Balances";
import { TRANSACTION_CATEGORY } from "@/constants/TransactionCategories";
import _ from "lodash";
import { logActivity } from '@/services/ActivityLogService';
const VouchersCollection = 'vouchers';
export const VoucherModule = {
    namespaced: true,
    state: [],
    mutations: {
        store(state, voucher) {
            const x = state.find(x => x.id === voucher.id);
            if (x) {
                if (_.isEqual(x, voucher)) {
                    return;
                }
                state.splice(state.indexOf(x), 1, voucher);
                store.dispatch('voucher/storeCache');
                return;
            }
            state.push(voucher);
            store.dispatch('voucher/storeCache');
        },
        update(state, voucher) {
            state.find((oldVoucher, index) => {
                if (oldVoucher.id === voucher.id) {
                    Vue.set(state, index, voucher);
                }
            });
        },
        destroy(state, voucher) {
            const index = state.findIndex(item => voucher.id === item.id);
            if (index !== -1) {
                Vue.set(state[index].data, 'deletedAt', voucher.data.deletedAt);
            }
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async store(context, voucher) {
            voucher.data.code = moment().year() + moment().unix().toString().slice(-6);
            voucher.data.remainingValue = voucher.data.value;
            // The sale income and the receipt are recorded by `payVoucher` once the money is collected.
            const document = await database.collection(VouchersCollection).add(voucher.data);
            voucher.id = document.id;
            // Log activity (fire-and-forget)
            logActivity('CREATE', 'voucher', voucher.data.code, null, voucher.data);
        },
        async update(context, voucher) {
            let document = await database.collection(VouchersCollection).doc(voucher.id);
            await document.update(voucher.data);
            // Log activity (fire-and-forget)
            logActivity('UPDATE', 'voucher', voucher.id, null, voucher.data);
        },
        async destroy(context, voucher) {
            // Log activity (fire-and-forget) - soft delete
            logActivity('DELETE', 'voucher', voucher.id, voucher.data, null);
            // soft delete - set deletedAt timestamp
            voucher.data.deletedAt = firebase.firestore.Timestamp.now();
            if (voucher.data.price >= 0) {
                const transaction = {
                    id: '',
                    data: {
                        from: 'cash',
                        to: BALANCES.MAIN_BALANCE,
                        dateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
                        createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                        value: -voucher.data.price,
                        category: TRANSACTION_CATEGORY.OTHER,
                        description: `Storno poukazu ${voucher.data.code}`,
                        deletedAt: null,
                    },
                };
                await store.dispatch('transaction/store', [transaction]);
            }
            const document = database.collection(VouchersCollection).doc(voucher.id);
            await document.update({ deletedAt: voucher.data.deletedAt });
        },
        async listen(context) {
            context.commit('clear');
            //await context.dispatch('loadCache');
            return database.collection(VouchersCollection).onSnapshot(snapshot => {
                for (let change of snapshot.docChanges()) {
                    switch (change.type) {
                        case 'added':
                            context.commit('store', { id: change.doc.id, data: change.doc.data() });
                            break;
                        case 'modified':
                            context.commit('update', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                        case 'removed':
                            context.commit('destroy', { id: change.doc.id, data: change.doc.data() });
                            context.dispatch('storeCache');
                            break;
                    }
                }
            });
        },
        async use(context, data) {
            if (data.voucher.data.remainingValue < data.value || (data.voucher.data.remainingValue <= 0 && data.value >= 0)) {
                throw new Error('Nedostatečná zbývající hodnota poukazu.');
            }
            if (moment(data.voucher.data.validTo, 'YYYY-MM-DD').isBefore(moment(), 'days')) {
                throw new Error('Platnost poukazu vypršela.');
            }
            data.voucher.data.remainingValue -= data.value;
            await context.dispatch('update', data.voucher);
            return data.voucher;
        },
        async storeCache(context) {
            localStorage.removeItem(VouchersCollection);
            try {
                localStorage.setItem(VouchersCollection, JSON.stringify(context.state));
            }
            catch (e) { }
        },
        async loadCache(context) {
            const cache = localStorage.getItem(VouchersCollection);
            if (!cache) {
                return;
            }
            const vouchers = JSON.parse(cache);
            for (const voucher of vouchers) {
                context.commit('store', { id: voucher.id, data: voucher.data });
            }
        },
    },
    getters: {
        // Active entities only (for selection dropdowns) - deletedAt is null, undefined, or missing
        active(state) {
            return state.filter(voucher => !voucher.data.deletedAt);
        },
        // All entities including deleted (for historical views)
        all(state) {
            return state;
        },
        // Deleted entities only
        deleted(state) {
            return state.filter(voucher => !!voucher.data.deletedAt);
        },
        // Active first, then deleted (for management list per FR-010)
        allSortedForManagement(state) {
            const active = state.filter(voucher => !voucher.data.deletedAt);
            const deleted = state.filter(voucher => !!voucher.data.deletedAt);
            return [...active, ...deleted];
        },
        get(state) {
            return (id) => state.find(voucher => voucher.id === id);
        },
    }
};
